module.exports = "<div class=\"form-selector\" ng-click=\"$ctrl.selectForm()\">\r\n  <span>{{$ctrl.toString()}}</span>\r\n  <!-- TODO: add use count metrics badge -->\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/forms/selector/selector-item.html
// module id = 3451
// module chunks = 0